import React from "react";
import { useTranslation } from "react-i18next";
import { AutoTextSize } from "auto-text-size";
import "./workexperience.css";

export default function CompanyDesc({ id }) {
  const { t } = useTranslation();

  return (
    <AutoTextSize minFontSizePx={12} className="overview-desc">
      {t(`experience.${id}.description`)}
    </AutoTextSize>
  );
}
